"use strict";

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Format = void 0;

var getPhone = function getPhone(value) {
  return value.replace(/ |-|(|)/g, '');
};

exports.Format = {
  getPhone: getPhone
};